module.exports = __webpack_public_path__ + "static/media/Hbook-04.41691fa1.jpg";